import { accordion } from "./accordion";
import { alerts } from "./alerts";
import backgrounds from "./backgrounds";
import buttons from "./buttons";
import cards from "./cards";
import colors, { gradients } from "./colors";
import forms from "./forms";
import { Hero } from "./hero";
import layout from "./layouts";
import modals from "./modals";
import spacing from "./spacing";
import { tables } from "./tables";
import { wordpress } from "./wordpress";
import typeography, {
  headingStyles,
  textStyles,
  lineHeights,
} from "./typeography";

const theme = {
  breakpoints: ["768px", "1025px", "1290px"],
  header: {
    zIndex: "999",

    position: "sticky",
    top: "0",
    left: "0",
    width: "100vw",
    filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
    height: ["50px", "70px"],
    bg: "primary",
    color: "white",
    logo: {
      color: "white",
      fontSize: 5,
    },
  },
  ...spacing,
  ...typeography,
  ...lineHeights,
  colors: { ...colors },
  ...tables,
  text: textStyles,
  styles: {
    root: {
      fontFamily: "body",
      lineHeight: "body",
      fontWeight: "body",
      fontSize: 2,
      bg: "white",
      ".builder-text": {
        ...textStyles,
        ...headingStyles,
        p: {
          a: {
            textDecoration: "underline",
          },
        },
      },
    },
    ...headingStyles,
    ...textStyles,
    blockQuote: {
      display: "block",
      borderWidth: "2px 0",
      borderStyle: "solid",
      borderColor: "#eee",
      padding: "1.5em 0 0.5em",
      margin: "1.5em 0",
      position: "relative",
      "::before": {
        content: "'\\201C'",
        position: "absolute",
        top: "0em",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        width: "3rem",
        height: "2rem",
        font: "6em/1.08em 'PT Sans', sans-serif",
        color: "primary",
        textAlign: "center",
      },
    },
    ".video-container": {
      overflow: "hidden",
      position: "relative",
      height: 400,
      iframe: {
        left: 0,
        top: 0,
        height: "100%",
        width: "100%",
        position: "absolute",
        borderRadius: "4px",
      },
    },

    ...tables,
    ...wordpress,
    ".faq": {
      color: "text",
      p: {
        color: "text",
        mb: 3,
      },
    },
  },
  gradients: { ...gradients },
  ...layout,
  ...buttons,
  ...cards,
  ...forms,
  ...alerts,
  ...accordion,
  footer: {
    width: "100%",
    minHeight: "300px",
  },
  hero: Hero,
  ...modals,

  ...backgrounds,
  quote: {
    variant: "backgrounds.primary.gradient.shadow",
  },

  links: {
    nav: {
      color: "primary",
      fontWeight: "thin",
      fontSize: [5, 3],
      "&.active": {
        fontWeight: "Bold",
      },
    },
  },
};

export default theme;
